import { Injectable } from "@angular/core";
import { ResourceService } from "@smartsoftware/reflex-core";
import { IdentitySubscription, SubscriptionType } from "../models/identitySubscription.model";
import { HttpClient, HttpResponse } from '@angular/common/http';
import { ReflexEnvironment as ENV } from "@smartsoftware/reflex-core";
import { map } from "rxjs/operators";


@Injectable()
export class IdentitySubscription_Service extends ResourceService<IdentitySubscription>{
    protected servicePath: string = '/IdentitySubscription';
    public ModelType = IdentitySubscription;

    constructor( protected http: HttpClient ){
        super(http);
    }

    // [SCS-1486] call openAPI to update the subscriptions, so we don't have to duplicate the logic 
    public updateSubscriptions(emails: string[], objectType: SubscriptionType, internal_uuid: string) {
        return this
            .http
            .post(
                ENV.config['openapiUrl'] + '/identitySubscription/updateSubscriptions',
                {
                    emails,
                    objectType,
                    internal_uuid
                },
                {
                    observe: 'response'
                }
            )
            .pipe(
                map(
                    (response: HttpResponse<any>) => {
                        console.debug('updateSubscriptions response:');
                        console.debug(response)
                        return response.body;
                    }
                )
            );
    }
}
